export default __webpack_public_path__ + "static/media/slav_m.3943ec99.jpg";